
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":".5","y":"3.5","width":"15","height":"8","fill":"#000"}},[_c('path',{attrs:{"fill":"#fff","d":"M.5 3.5h15v8H.5z"}}),_c('path',{attrs:{"d":"M4.582 7.966v2.812h-.693V7.966H1.228v-.65h2.66V4.504h.694v2.812h2.661v.65H4.582zm4.116-1.01v-.65h6.016v.65H8.698zm0 2.025v-.649h6.016v.65H8.698z"}})]),_c('path',{attrs:{"d":"M4.582 7.966v2.812h-.693V7.966H1.228v-.65h2.66V4.504h.694v2.812h2.661v.65H4.582zm4.116-1.01v-.65h6.016v.65H8.698zm0 2.025v-.649h6.016v.65H8.698z","fill":"#748190"}}),_c('path',{attrs:{"d":"M4.582 7.966v-.2h-.2v.2h.2zm0 2.812v.2h.2v-.2h-.2zm-.693 0h-.2v.2h.2v-.2zm0-2.812h.2v-.2h-.2v.2zm-2.661 0h-.2v.2h.2v-.2zm0-.65v-.2h-.2v.2h.2zm2.66 0v.2h.2v-.2h-.2zm0-2.812v-.2h-.2v.2h.2zm.694 0h.2v-.2h-.2v.2zm0 2.812h-.2v.2h.2v-.2zm2.661 0h.2v-.2h-.2v.2zm0 .65v.2h.2v-.2h-.2zm-2.861 0v2.812h.4V7.966h-.4zm.2 2.612h-.693v.4h.693v-.4zm-.493.2V7.966h-.4v2.812h.4zm-.2-3.012H1.228v.4h2.66v-.4zm-2.461.2v-.65h-.4v.65h.4zm-.2-.45h2.66v-.4h-2.66v.4zm2.86-.2V4.504h-.4v2.812h.4zm-.2-2.612h.694v-.4h-.693v.4zm.494-.2v2.812h.4V4.504h-.4zm.2 3.012h2.661v-.4H4.582v.4zm2.461-.2v.65h.4v-.65h-.4zm.2.45H4.582v.4h2.661v-.4zm1.455-.81h-.2v.2h.2v-.2zm0-.65v-.2h-.2v.2h.2zm6.016 0h.2v-.2h-.2v.2zm0 .65v.2h.2v-.2h-.2zM8.698 8.98h-.2v.2h.2v-.2zm0-.649v-.2h-.2v.2h.2zm6.016 0h.2v-.2h-.2v.2zm0 .65v.2h.2v-.2h-.2zM8.898 6.954v-.65h-.4v.65h.4zm-.2-.45h6.016v-.4H8.698v.4zm5.816-.2v.65h.4v-.65h-.4zm.2.45H8.698v.4h6.016v-.4zM8.898 8.981v-.649h-.4v.65h.4zm-.2-.449h6.016v-.4H8.698v.4zm5.816-.2v.65h.4v-.65h-.4zm.2.45H8.698v.4h6.016v-.4z","fill":"#748190","mask":"url(#a)"}})])
          )
        }
      }
    